import React from 'react';
import PropTypes from 'prop-types';

const RectangleTag = (props): JSX.Element => {
  const {
    color,
    size,
    text,
    margins,
    borderInfo,
  } = props;
  return (
    <div
      style={{
        backgroundColor: color,
        width: size,
        height: size,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: margins.marginTop,
        marginRight: margins.marginRight,
        marginBottom: margins.marginBottom,
        marginLeft: margins.marginLeft,
        borderColor: borderInfo.borderColor,
        borderStyle: borderInfo.borderStyle,
        borderWidth: borderInfo.borderWidth,
      }}
    >
      {text && <span>{text}</span>}
    </div>
  );
};

RectangleTag.propTypes = {
  size: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  text: PropTypes.string,

  margins: PropTypes.shape({
    marginTop: PropTypes.string,
    marginRight: PropTypes.string,
    marginBottom: PropTypes.string,
    marginLeft: PropTypes.string,
  }),

  borderInfo: PropTypes.shape({
    borderStyle: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.string,
  }),
};

RectangleTag.defaultProps = {
  text: '',

  margins: {
    marginTop: '0px',
    marginRight: '0px',
    marginBottom: '0px',
    marginLeft: '0px',
  },

  borderInfo: {
    borderStyle: 'unset',
    borderColor: '',
    borderWidth: '0px',
  },
};

export default RectangleTag;
